// get parent using selector
const getClosest = (elem, selector) => {
    for (
        let element = elem;
        element && element !== document;
        element = element.parentNode
    ) {
        if (element.matches(selector)) return element;
    }
    return null;
};

// handle promise response
const handleResponse = (response) => response.json().then((json) => {
    if (response.ok) return json;

    const error = Object.assign(...json, {
        status: response.status,
        statusText: response.statusText,
    });

    return Promise.reject(error);
});

// capitalise first letters
const capFirstLetter = (string) => {
    const words = string.split(' ');

    for (let i = 0; i < words.length; i += 1) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(' ');
};

// title case string
const titleCase = (str) => {
    const strArr = str.toLowerCase().split(' ');

    for (let i = 0; i < strArr.length; i += 1) {
        strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
    }

    return strArr.join(' ');
};

// get URL parameters
const getUrlParams = (url) => {
    // get query string from url (optional) or window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    const obj = {};

    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        [queryString] = queryString.split('#');

        // split our query string into its component parts
        const arr = queryString.split('&');

        for (let i = 0; i < arr.length; i += 1) {
            // separate the keys and the values
            const a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            let paramName = a[0];
            let paramValue = typeof a[1] === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') {
                paramValue = paramValue.toLowerCase();
            }

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {
                // create key if it doesn't exist
                const key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    const index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
                // we're dealing with a string
            } else if (!obj[paramName]) {
                // if it doesn't exist, create property
                obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                // if property does exist and it's a string, convert it to an array
                obj[paramName] = [obj[paramName]];
                obj[paramName].push(paramValue);
            } else {
                // otherwise add the property
                obj[paramName].push(paramValue);
            }
        }
    }

    return obj;
};

// wait for event
const waitForEvent = (element, eventName) => (
    new Promise((resolve) => {
        const done = (event) => {
            if (event.target === element) {
                element.removeEventListener(eventName, done);
                resolve(event);
            }
        };
        element.addEventListener(eventName, done);
    })
);

const loaderHTML = `
    <div class="flex items-center justify-center absolute top-0 left-0 z-50 w-full h-full bg-white bg-opacity-75 js-loader">
        <svg
            class="w-24"
            viewBox="0 0 100 100">
            <path
                fill="#e0e483"
                d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="1s"
                    from="0 50 50"
                    to="360 50 50"
                    repeatCount="indefinite" />
            </path>
        </svg>
    </div>
`;

export {
    getClosest,
    handleResponse,
    capFirstLetter,
    titleCase,
    getUrlParams,
    waitForEvent,
    loaderHTML,
};
